"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PHONE_REGEXP = void 0;
exports.PHONE_REGEXP = new RegExp(/^(?:(\+)([1-9]{2}))?(\d{7,10})$/);
